var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_980_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_983_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_984_",
    d: "M24.38,23.36H1.62c-0.9,0-1.62-0.73-1.62-1.62V4.27c0-0.9,0.73-1.62,1.62-1.62h22.75 c0.9,0,1.62,0.73,1.62,1.62v17.47C26,22.63,25.27,23.36,24.38,23.36z M1.62,4.27v17.47h22.75l0-17.47H1.62z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_981_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_982_",
    points: "9.18,6.05 9.18,19.95 18.86,13  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.d102239022e3dd113087697a6be8fcd4.svg";
export { ForwardRef as ReactComponent };